/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MarkupV2ListItem,
    MarkupV2ListItemFromJSON,
    MarkupV2ListItemFromJSONTyped,
    MarkupV2ListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupV2ListItemPaginationWrapper
 */
export interface MarkupV2ListItemPaginationWrapper {
    /**
     * 
     * @type {Array<MarkupV2ListItem>}
     * @memberof MarkupV2ListItemPaginationWrapper
     */
    items?: Array<MarkupV2ListItem> | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupV2ListItemPaginationWrapper
     */
    totalItems?: number;
}

export function MarkupV2ListItemPaginationWrapperFromJSON(json: any): MarkupV2ListItemPaginationWrapper {
    return MarkupV2ListItemPaginationWrapperFromJSONTyped(json, false);
}

export function MarkupV2ListItemPaginationWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupV2ListItemPaginationWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(MarkupV2ListItemFromJSON)),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
    };
}

export function MarkupV2ListItemPaginationWrapperToJSON(value?: MarkupV2ListItemPaginationWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(MarkupV2ListItemToJSON)),
        'totalItems': value.totalItems,
    };
}


